import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from './ui/button';

export const BackButton = ({ to = '/dashboard', label = 'Back to Dashboard', variant = 'default' }) => {
  const navigate = useNavigate();

  if (variant === 'home') {
    return (
      <Button
        onClick={() => navigate(to)}
        className="md:hidden fixed bottom-6 left-6 z-50 bg-[#064E3B] hover:bg-[#065F46] text-white shadow-2xl rounded-full h-14 w-14"
        title={label}
      >
        <Home className="h-6 w-6 md:mr-2" />
        <span className="hidden md:inline">{label}</span>
      </Button>
    );
  }

  return (
    <Button
      onClick={() => navigate(to)}
      variant="ghost"
      className="mb-4 hover:bg-gray-100 dark:hover:bg-gray-800"
    >
      <ArrowLeft className="h-4 w-4 mr-2" />
      {label}
    </Button>
  );
};

export default BackButton;
